import { render } from "./StandardHospital.vue?vue&type=template&id=3836974a&scoped=true"
import script from "./StandardHospital.vue?vue&type=script&lang=js"
export * from "./StandardHospital.vue?vue&type=script&lang=js"

import "./StandardHospital.vue?vue&type=style&index=0&id=3836974a&scoped=true&lang=css"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3836974a"]])

export default __exports__